var map = {
	"./c1.png": "./src/assets/img/document/c1.png",
	"./c2.png": "./src/assets/img/document/c2.png",
	"./c3.png": "./src/assets/img/document/c3.png",
	"./c4.png": "./src/assets/img/document/c4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/document sync recursive ^\\.\\/c.*\\.png$";